import React, { useEffect, useMemo, useState } from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import { formTypes } from '../formTypes';

const cx = classNames.bind(styles);

export const Stepper = ({ modalType, activeStep, setActiveStep, validSteps }) => {
  const form = useMemo(() => formTypes.find((t) => t.name === modalType.name), [modalType]);
  const { steps } = form || [];
  const [visitedSteps, setVisitedSteps] = useState([activeStep]);

  useEffect(() => {
    setVisitedSteps((current) => [...current, activeStep]);
  }, [activeStep]);

  const showSteps = useMemo(
    () =>
      steps.reduce(
        (acc, step, index) =>
          index === 0
            ? [
                ...acc,
                {
                  line: null,
                  number: (
                    <li
                      key={`number-${index}`}
                      aria-current={activeStep === index ? 'step' : undefined}
                    >
                      <button
                        aria-label={`Schritt ${step.number} von 4: ${step.label}`}
                        className={cx(
                          styles.number,
                          activeStep === index ? styles.numberActive : styles.numberVisited
                        )}
                        onClick={
                          activeStep !== index &&
                          (activeStep > index || visitedSteps.includes(index))
                            ? () => {
                                const lower = index < activeStep;
                                const next = index === activeStep + 1;
                                const nextEnabled = validSteps[index];
                                const higher = index > activeStep;
                                const higherEnabled = validSteps.every((t) => t);

                                if (lower || (next && nextEnabled) || (higher && higherEnabled)) {
                                  setActiveStep(index);
                                }
                              }
                            : undefined
                        }
                      >
                        {step.number}
                      </button>
                    </li>
                  ),
                  text: (
                    <div
                      key={`text-${index}`}
                      aria-hidden
                      className={cx(
                        styles.text,
                        activeStep === index ? styles.textActive : styles.textVisited
                      )}
                    >
                      {step.label}
                    </div>
                  ),
                },
              ]
            : [
                ...acc,
                {
                  line: (
                    <div
                      key={`line-${index}`}
                      className={cx(
                        styles.line,
                        activeStep >= index || visitedSteps.includes(index)
                          ? styles.lineActive
                          : styles.line
                      )}
                    />
                  ),
                  number: (
                    <li
                      key={`number-${index}`}
                      aria-current={activeStep === index ? 'step' : undefined}
                    >
                      <button
                        aria-label={`Schritt ${step.number} von 4: ${step.label}${
                          activeStep > index || visitedSteps.includes(index)
                            ? ''
                            : ' - noch nicht wählbar'
                        }`}
                        className={cx(
                          styles.number,
                          activeStep === index
                            ? styles.numberActive
                            : activeStep >= index || visitedSteps.includes(index)
                              ? styles.numberVisited
                              : null
                        )}
                        onClick={
                          activeStep !== index &&
                          (activeStep > index || visitedSteps.includes(index))
                            ? () => {
                                const lower = index < activeStep;
                                const next = index === activeStep + 1;
                                const nextEnabled = validSteps[index - 1];
                                const higher = index > activeStep;
                                const higherEnabled = validSteps.every((t) => t);

                                if (lower || (next && nextEnabled) || (higher && higherEnabled)) {
                                  setActiveStep(index);
                                }
                              }
                            : undefined
                        }
                      >
                        {step.number}
                      </button>
                    </li>
                  ),
                  text: (
                    <div
                      key={`text-${index}`}
                      aria-hidden
                      className={cx(
                        styles.text,
                        activeStep === index ? styles.textActive : styles.textVisited
                      )}
                    >
                      {step.label}
                    </div>
                  ),
                },
              ],
        []
      ),
    [activeStep, visitedSteps, validSteps]
  );

  if (activeStep === undefined) {
    return null;
  }

  return (
    <nav className={cx(styles.container)} aria-label="Schritte dieses Formulars">
      <div className={cx(styles.containerNumbersLines)}>
        <div className={cx(styles.containerLines)}>{showSteps.map((step) => step.line)}</div>
        <ul className={cx(styles.containerNumbers)}>{showSteps.map((step) => step.number)}</ul>
      </div>
      <div className={cx(styles.containerTexts)}>{showSteps.map((step) => step.text)}</div>
    </nav>
  );
};
